import { assertUnreachable } from "common/utils/assertUnreachable";

export enum TextAlignment {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum TextVerticalAlignment {
  TOP = "TOP",
  CENTER = "CENTER",
  BOTTOM = "BOTTOM",
}

export enum PlacementXAnchor {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum PlacementYAnchor {
  TOP = "TOP",
  CENTER = "CENTER",
  BOTTOM = "BOTTOM",
}

export type NamedTextAlignmentX = "center" | "left" | "right";

export function textAlignmentToXAnchor(textAlign: TextAlignment | undefined): PlacementXAnchor | undefined {
  switch (textAlign) {
    case TextAlignment.LEFT:
      return PlacementXAnchor.LEFT;
    case TextAlignment.CENTER:
      return PlacementXAnchor.CENTER;
    case TextAlignment.RIGHT:
      return PlacementXAnchor.RIGHT;
    default:
      return textAlign;
  }
}

export function textVerticalAlignmentToYAnchor(
  textVerticalAlignment: TextVerticalAlignment | undefined,
): PlacementYAnchor | undefined {
  switch (textVerticalAlignment) {
    case TextVerticalAlignment.TOP:
      return PlacementYAnchor.TOP;
    case TextVerticalAlignment.CENTER:
      return PlacementYAnchor.CENTER;
    case TextVerticalAlignment.BOTTOM:
      return PlacementYAnchor.BOTTOM;
    default:
      return textVerticalAlignment;
  }
}

export function textAlignmentToNamedAlignment(alignment: TextAlignment): NamedTextAlignmentX {
  switch (alignment) {
    case TextAlignment.LEFT:
      return "left";
    case TextAlignment.CENTER:
      return "center";
    case TextAlignment.RIGHT:
      return "right";
    default:
      assertUnreachable(alignment);
  }
}
